// extracted by mini-css-extract-plugin
export default {"active":"Cart_active__2yCcK","inActive":"Cart_inActive__VZxSE","box":"Cart_box__Ss4Tz","iconWrapper":"Cart_iconWrapper__QjzVE","icon":"Cart_icon__veclk","label":"Cart_label__-9+QW"};